import { Message } from "../../../adapters/insights-agent/state/AppState.ts";
import { CitationMarkerInjector } from "./CitationMarkerInjector.ts";
const citationMarkerInjector = new CitationMarkerInjector();
citationMarkerInjector.citationMarkerPrefix = "[";
citationMarkerInjector.citationMarkerSuffix = "]";
export const makeCopyText = (
  message: Pick<Message, "value" | "citations" | "references">,
): string => {
  if (!message.value) return "";
  if (!message.citations || message.citations.length === 0)
    return message.value;

  const citationText = message.citations
    .flatMap((citation) =>
      citation.referenceIds.map((referenceId) => {
        const reference = message.references?.find(
          (ref) => ref.id === referenceId,
        );
        if (reference) {
          return `[${referenceId}] ${reference.title}, ${reference.page} - ${reference.sourceUrl}`;
        }
        return "";
      }),
    )
    .filter(Boolean)
    .join("\n\n");
  const messageWithCitations = citationMarkerInjector.injectMarkers(
    message.value,
    message.citations,
  );
  return `${messageWithCitations}\n\n${citationText}`;
};
